"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SelloutIdentificationDTO_1 = require("../model/sellout-identification/SelloutIdentificationDTO");

var SelloutIdentificationDTOConverter_1 = require("./SelloutIdentificationDTOConverter");

var SelloutTypeWithItemCountsConverter_1 = require("./SelloutTypeWithItemCountsConverter");
/**
 * @author Adam Drda
 */


var SelloutIdentificationDTOConverterImpl =
/*#__PURE__*/
function (_SelloutIdentificatio) {
  _inherits(SelloutIdentificationDTOConverterImpl, _SelloutIdentificatio);

  function SelloutIdentificationDTOConverterImpl(selloutTypeWithItemCountsConverter) {
    var _this;

    _classCallCheck(this, SelloutIdentificationDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDTOConverterImpl).call(this));
    _this.selloutTypeWithItemCountsConverter = selloutTypeWithItemCountsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutIdentificationDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutIdentificationDTO_1.SelloutIdentificationDTO(SelloutIdentificationDTO_1.SelloutIdentificationDTO.schema.categoryId.valueOf(conversions.toClassReferenceId(source.categoryId)), SelloutIdentificationDTO_1.SelloutIdentificationDTO.schema.dataPerCategory.valueOf(conversions.asObjectList(source, 'dataPerCategory', function (obj) {
        return _this2.selloutTypeWithItemCountsConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        dataPerCategory: conversions.asObjectArray(source, 'dataPerCategory', function (obj) {
          return _this3.selloutTypeWithItemCountsConverter.toDocument(obj, conversions);
        })
      };
    }
  }]);

  return SelloutIdentificationDTOConverterImpl;
}(SelloutIdentificationDTOConverter_1.SelloutIdentificationDTOConverter);

SelloutIdentificationDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutTypeWithItemCountsConverter_1.SelloutTypeWithItemCountsConverter])], SelloutIdentificationDTOConverterImpl);
exports.SelloutIdentificationDTOConverterImpl = SelloutIdentificationDTOConverterImpl;